import { useContext, useEffect } from "react";
import { Spinner, Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import PaginationList from "./../../../utils/PaginationList/PaginationList";
import OnTypeSearch from "../../../utils/OnTypeSearch/OnTypeSearch";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { backUpAdminContext } from "../../../context/Admin/BackUpAdminContext/BackUpAdminContext";
import {
  backUpPermissionItems,
  convertBackUpPermissionToText,
} from "../../../utils";

const BackUpAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const { backUps, handleGetBackUps, handleGetBackUp } =
    useContext(backUpAdminContext);

  useEffect(() => {
    handleGetBackUps();
  }, []);

  return (
    <>
      <SiteTitle title="پشتیبان گیری" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/BackUp/Dashboard", type: "l" },
          { name: "پشتیبان گیری", type: "a" },
        ]}
        title="لیست پشتیبان گیری"
      />

      <CardLayout>
        {isEmpty(backUps) ? (
          <EmptyData />
        ) : (
          <>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>نام</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {backUps.length}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {backUps.slice(2).map((_item, index) => (
                  <tr key={_item}>
                    <td>{index + 1}</td>
                    <td>{_item}</td>
                    <td className="mw-25">
                      <button
                        onClick={() => handleGetBackUp(_item)}
                        className="btn btn-info mr-2"
                      >
                        دانلود
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>
    </>
  );
};

export default BackUpAdmin;
